// ######################################################
//   Un tramo es una línea que va del punto A al punto B donde A y B son las
// coordenadas usadas para definir un perímtero en los editores.
//   Un tramo esta dividido en sub-secciones, debe existir una como mínimo.
//   Una sub-sección es por ejemplo una puerta, una verja o cercado sin muro ...
//
//   subSecction {
//		lat, lng		// Latitud y longitud.
//	  	x1, y1, z1		// Puntos A de la sub-sección.
//	  	x2, y2, z2		// Puntos B de la sub-sección.
//    	height			// Altura en caso de que exista muro o escalones, (es la suma de ambos).
//    	magnitud		// Longitud de la sub-sección.
//    	door			// Es el ID de mongoDG, describe el tipo de puerta.
//   }
// ######################################################

import * as THREE from 'three';

export class SubSectionSatelite {
	public p1: THREE.Vector3;
	public p2: THREE.Vector3;

	public height = 0;

	public magnitud: number;

	public door = '';

	// El poste base del tramo se ve obligado a moverse en x+, cuando:
	// 1.- El tramo anterior era una puerta.
	// 2.- La subsección del tramo anterior es más alto que el actual.
	public marginA = 0;

	// Cuando el poste base del siguiente tramo es obligado a moverse en x-, cuando:
	// 1.- El siguiente tramo es una puerta, se crea un nuevo poste y se desplaza (x = magnitud - 0.035).
	public marginB = 0;

	constructor(height = 0) {
		this.height = height;
		this.p1 = new THREE.Vector3();
		this.p2 = new THREE.Vector3();
		this.magnitud = 0;
	}

	public setCoordinates(v1: THREE.Vector3, v2: THREE.Vector3) {
		this.p1.copy(v1);
		this.p2.copy(v2);
		
		// const p1 = new THREE.Vector3().copy(v1);
		// const p2 = new THREE.Vector3().copy(v2);
		// p1.z = 0;
		// p2.z = 0;
		// this.magnitud = p1.distanceTo(p2);

		this.magnitud = this.p1.distanceTo(this.p2);
	}

	public setCoordinateP1(v1: THREE.Vector3) {
		this.p1.copy(v1);

		// const p1 = new THREE.Vector3().copy(v1);
		// const p2 = this.p2.clone();
		// p1.z = 0;
		// p2.z = 0;
		// this.magnitud = p1.distanceTo(p2);

		this.magnitud = this.p1.distanceTo(this.p2);
	}
	
	public setCoordinateP2(v2: THREE.Vector3) {
		this.p2.copy(v2);

		// const p1 = this.p1.clone();
		// const p2 = new THREE.Vector3().copy(v2);
		// p1.z = 0;
		// p2.z = 0;
		// this.magnitud = p1.distanceTo(p2);

		this.magnitud = this.p1.distanceTo(this.p2);
	}

	public clonarElevation(magnitud = -1): SubSectionSatelite {
		let newSection = new SubSectionSatelite;
		newSection.setCoordinates(this.p1, this.p2);
		if (magnitud > -1) newSection.magnitud = magnitud;
		return newSection;
	}
}